import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Confirm, Modal } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { appLoading } from 'ducks/app'
import { createVM, getWorkflowEditMode, clearVMFormData, checkTaxIdAvailable } from 'ducks/vendorMaintenance'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { checkAttachmentRequire } from '../AttributeData'
import { vmPath } from 'routes'
import { 
  AccountingForm, 
  AttachmentForm, 
  GeneralForm, 
  PurchasingForm, 
  RequestForm,
  Approvers
} from '../Form'
import { VendorMaintenanceContainer, VendorMaintenanceBody } from '../Form/styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'

const VendorMaintenanceCreate = (props) => {
  const { valueForm } = props
  const { requesterUser, createdBy, purpose, companyCode } = valueForm
  const [submit, setSubmit] = useState(false)
  const [mainFormClickSave, setMainFormClickSave] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    // props.getHrmsMembers(false)
    props.getAllMembers(false)
    return () => {
      props.clearVMFormData()
    }
  }, [])

  useEffect(() => {
    if (requesterUser && createdBy && purpose && companyCode ) {
      props.getWorkflowEditMode({ requester: requesterUser, creator: createdBy, purpose, companyCode })
    }
  }, [requesterUser, createdBy, purpose, companyCode])

  const onSubmitCreateForm = (values) => {
    const { createVM, history, appLoading, attachmentGroups } = props

    if (mainFormClickSave) {
      if (submit) {
        let errors = {}
        
        if (values.purpose === 'create' || values.purpose === 'change') {
          const documentTypes = attachmentGroups.data.find(a => a.bpGroup === values.accountGroup) || { attachments: [] }
          
          if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP','ZOTV'].includes(values.accountGroup)) {
            if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
              if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
                errors.notRegisterRemark = 'Required!'
              }
            }
          }
  
          if (values.paymentTypeTransfer) {
            if ((values.vendorBanks || []).length === 0) {
              errors.paymentType = ' Minimum 1 row of bank account required!'
            }

            if ((values.vendorUsers || []).length > 0) {
              if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
                errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
              }
            } else {
              errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
            }
          }
  
          documentTypes.attachments.forEach(d => {
            if (checkAttachmentRequire(d, values)) {
              if ((values[d.code] || []).length === 0) {
                errors[d.code] = 'Require!'
              }
            }
          })

          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
      
          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
        }

        if (values.purpose === 'copy') {
          validations(values, 'copyType', [vCase.require], errors)
      
          if (values.copyType === 'company') {
            if ((values.companies || []).length === 0) {
              errors.companies = 'Require!'
            }
          }
      
          if (values.copyType === 'purchasingOrg') {
            validations(values, 'purchasingOrg', [vCase.require], errors)
      
            if (values.purchasingOrg) {
              if ((values.copyPurchasingOrg || []).length === 0) {
                errors.copyPurchasingOrg = 'Require!'
              }
            }
          }
        }

        if (values.purpose === 'create' || values.purpose === 'copy') {
          if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
            if (values.receiveEWht === null || values.receiveEWht === undefined) {
              errors.receiveEWht = 'Require!'
            }
          }
        }

        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          const { purpose, vendorCode, vendorType, taxId, accountGroup } = values
          if ((purpose === 'create' || purpose === 'change') && accountGroup !== 'ZFOV') {
            props.checkTaxIdAvailable(
              { vendorCode, vendorType, taxId, accountGroup }, 
              () => { createVM(values, submit, history, appLoading) }, 
              (message) => {
                if (message.startsWith('Tax ID has been created by Business Partner E') && accountGroup === 'ZEMP') {
                  setShowErrorModal(true)
                  setErrorMessage(message)
                } else {
                  setShowConfirmModal(true)
                  setConfirmMessage(message)
                }
              }
            )
          } else {
            createVM(values, submit, history, appLoading)
          }
        }
      } else {
        let errors = {}

        if (values.purpose === 'create' || values.purpose === 'change') {
          if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(values.accountGroup)) {
            if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
              if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
                errors.notRegisterRemark = 'Required!'
              }
            }
          }
  
          if (values.paymentTypeTransfer) {
            if ((values.vendorBanks || []).length === 0) {
              errors.paymentType = ' Minimum 1 row of bank account required!'
            }
      
            if ((values.vendorUsers || []).length > 0) {
              if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
                errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
              }
            } else {
              errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
            }
          }

          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
      
          if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
            validations(values, 'reconciliationAccount', [vCase.require], errors)
            validations(values, 'sortKey', [vCase.require], errors)
            validations(values, 'planningGroup', [vCase.require], errors)
            validations(values, 'accPaymentTerms', [vCase.require], errors)
            validations(values, 'paymentMethod', [vCase.require], errors)
            validations(values, 'tradingPartner', [vCase.require], errors)
            validations(values, 'branchCode', [vCase.require], errors)
            validations(values, 'branchDescription', [vCase.require], errors)
          }
        }

        if (values.purpose === 'copy') {
          validations(values, 'copyType', [vCase.require], errors)
      
          if (values.copyType === 'company') {
            if ((values.companies || []).length === 0) {
              errors.companies = 'Require!'
            }
          }
      
          if (values.copyType === 'purchasingOrg') {
            validations(values, 'purchasingOrg', [vCase.require], errors)
      
            if (values.purchasingOrg) {
              if ((values.copyPurchasingOrg || []).length === 0) {
                errors.copyPurchasingOrg = 'Require!'
              }
            }
          }
        }

        if (values.purpose === 'create' || values.purpose === 'copy') {
          if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
            if (values.receiveEWht === null || values.receiveEWht === undefined) {
              errors.receiveEWht = 'Require!'
            }
          }
        }

        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          createVM(values, submit, history, appLoading)
        }
      }
      setMainFormClickSave(false)
    }
  }

  return (
    <MainBodyContent 
      headerTitle='Vendor Maintenance - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'VM', content: 'Vendor Maintenance', link: true, onClick: () => props.history.push(vmPath) },
              { key: 'VMCreate', content: 'Create', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
          {
            (purpose === 'create' || purpose === 'change' || purpose === 'block') && companyCode ?
              <Approvers loading={props.workflowEdit.loading} approvers={props.workflowEdit.data  || []} /> : null
          }
        </div>
      }
    >
      <VendorMaintenanceContainer>
        <VendorMaintenanceBody>
          <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
            <RequestForm change={props.change} valueForm={valueForm}/>
            <GeneralForm change={props.change} valueForm={valueForm}/>
            {
              valueForm.purpose === 'block' || 
              valueForm.purpose === 'copy' ||
              valueForm.accountGroup === 'ZEMP' ? null : 
                <PurchasingForm change={props.change} valueForm={valueForm}/>
            }
            {
              (valueForm.accountGroup === 'ZRPT'||valueForm.accountGroup === 'ZRCP') && (valueForm.purpose === 'create' || valueForm.purpose === 'change') ? 
                <AccountingForm isDisplay={false} change={props.change} valueForm={valueForm}/> : null
            }
            {
              valueForm.purpose === 'block' || valueForm.purpose === 'copy' ? null : 
                <AttachmentForm change={props.change} valueForm={valueForm}/>
            }
            <div className='btnContainer'>
              <div className='left'></div>
              <div className='right'>
                <Button
                  type='submit'
                  content='Save'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setMainFormClickSave(true)
                    setSubmit(false)
                  }}
                />
                <Button
                  type='submit'
                  content='Save & Submit'
                  color='blue'
                  icon='save'
                  labelPosition='right'
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setMainFormClickSave(true)
                    setSubmit(true)
                  }}
                />
              </div>
            </div>
          </form>
        </VendorMaintenanceBody>
      </VendorMaintenanceContainer>
      <Confirm 
        open={showConfirmModal}
        header='Warning!'
        content={
          <div style={{ padding: '1.25rem' }}>
            <p>{confirmMessage}</p>
            {
              valueForm.purpose === 'create' ?
                <p>Are you sure to create new Business Partner Code?</p> :
              valueForm.purpose === 'change' ?
                <p>Are you sure to change Business Partner Data?</p> : null
            }
          </div>
        }
        confirmButton='Yes'
        cancelButton='No'
        onConfirm={() => {
          setShowConfirmModal(false)
          props.createVM(valueForm, submit, props.history, props.appLoading)
        }}
        onCancel={() => setShowConfirmModal(false)}
      />
      <Modal
        open={showErrorModal}
        onClose={() => {
          setShowErrorModal(false)
          setErrorMessage('')
        }}
      >
        <Modal.Header>Can't Submit Business Partner!</Modal.Header>
        <Modal.Content>
          {errorMessage}
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => {
            setShowErrorModal(false)
            setErrorMessage('')
          }}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  const fullname = state.authen.user ? state.authen.user.fullname ? state.authen.user.fullname : '' : ''
  const vf = getFormValues('formVendorMaintenance')(state) || {}

  return ({
    valueForm: vf,
    attachmentGroups: state.vendorMaintenance.attachmentGroups,
    workflowEdit: state.vendorMaintenance.workflowEdit,
    initialValues: {
      ...vf,
      requesterUser: vf.requesterUser ? vf.requesterUser : username,
      requesterName: vf.requesterName ? vf.requesterName : fullname,
      createdBy: vf.createdBy ? vf.createdBy : username,
      createdByName: vf.createdByName ? vf.createdByName : fullname,
      documentDate: vf.documentDate ? vf.documentDate : new Date(),
      standardIndustry: vf.standardIndustry !== undefined ? vf.standardIndustry : true,
      vendorUsers: vf.vendorUsers ? vf.vendorUsers : [],
      paymentTypeTransfer: vf.paymentTypeTransfer !== undefined ? vf.paymentTypeTransfer : true,
      vendorBanks: vf.vendorBanks ? vf.vendorBanks : [],
      paymentMethod: vf.paymentMethod ? vf.paymentMethod : ['C', 'E', 'T', 'P', 'B', 'K'],
      checkDoubleInvoice: vf.checkDoubleInvoice !== undefined ? vf.checkDoubleInvoice : true,
      payeeInDocument: vf.payeeInDocument !== undefined ? vf.payeeInDocument : true,
      branchCode: vf.branchCode !== undefined ? vf.branchCode : '00000',
      branchDescription: vf.branchDescription !== undefined ? vf.branchDescription : 'สำนักงานใหญ่',
      purchasingViewLoaded: vf.purchasingViewLoaded !== undefined ? vf.purchasingViewLoaded : false,
      accountingViewLoaded: vf.accountingViewLoaded !== undefined ? vf.accountingViewLoaded : false,
      isFromVendor: false
    }
  })
}

const mapDispatchToProps = {
  createVM,
  appLoading,
  getWorkflowEditMode,
  clearVMFormData,
  checkTaxIdAvailable,
  getHrmsMembers,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'title', [vCase.require, vCase.maxLength200], errors)
  validations(values, 'requesterUser', [vCase.require], errors)
  validations(values, 'documentDate', [vCase.require], errors)
  validations(values, 'purpose', [vCase.require], errors)
  validations(values, 'accountGroup', [vCase.require], errors)

  if (values.purpose === 'create' || values.purpose === 'change') {
    validations(values, 'companyCode', [vCase.require], errors)
    validations(values, 'vendorType', [vCase.require], errors)
    validations(values, 'vendorName1', [vCase.require, vCase.maxLength40], errors)
    validations(values, 'vendorName2', [vCase.maxLength40], errors)
    validations(values, 'vendorName3', [vCase.maxLength40], errors)
    validations(values, 'vendorName4', [vCase.maxLength40], errors)
    validations(values, 'searchName', [vCase.require, vCase.maxLength20], errors)

    validations(values, 'industry', [vCase.require], errors)
    if (values.purpose !== 'block') {
      if (values.accountGroup === 'ZFOV') {
        validations(values, 'taxId', [vCase.maxLength13], errors)
      } else {
        validations(values, 'taxId', [vCase.require, vCase.maxLength13], errors)
      }
    }
    
    validations(values, 'country', [vCase.require], errors)
    validations(values, 'province', [vCase.require], errors)
    validations(values, 'district', [vCase.require], errors)
    validations(values, 'subDistrict', [vCase.require], errors)
    validations(values, 'houseNumber', [vCase.require, vCase.maxLength10], errors)
    validations(values, 'buildingOrRoomNo', [vCase.require, vCase.maxLength60], errors)
    validations(values, 'street', [vCase.maxLength40], errors)
    validations(values, 'postalCode', [vCase.require, vCase.maxLength10], errors)

    if (['ZDOV', 'ZFOV', 'ZRPT', 'ZRCP', 'ZOTV'].includes(values.accountGroup)) {
      if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
        validations(values, 'notRegisterRemark', [vCase.require], errors)
      }
    }
    
    if (values.paymentTypeTransfer) {
      if ((values.vendorBanks || []).length === 0) {
        errors.paymentType = ' Minimum 1 row of bank account required!'
      }

      if ((values.vendorUsers || []).length > 0) {
        if ((values.vendorUsers || []).filter(u => u.receiveChequeAtBank === true).length === 0) {
          errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
        }
      } else {
        errors.userErrorMessage = ' Minimum 1 user of receive payment notification required!'
      }
    }

    if (values.usePurchasingView) {
      if (values.purpose === 'create' || values.purpose === 'change') {
        validations(values, 'purchasingOrg', [vCase.require], errors)
      }

      validations(values, 'orderCurrency', [vCase.require], errors)
      validations(values, 'paymentTerms', [vCase.require], errors)

      if (values.incoterm !== undefined && values.incoterm !== null && values.incoterm !== '') {
        validations(values, 'incotermsLocation', [vCase.require], errors)
      }
    }

    if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'create') {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }

    if ((values.accountGroup === 'ZRPT'||values.accountGroup === 'ZRCP') && values.purpose === 'change' && values.accountingViewLoaded === true) {
      validations(values, 'reconciliationAccount', [vCase.require], errors)
      validations(values, 'sortKey', [vCase.require], errors)
      validations(values, 'planningGroup', [vCase.require], errors)
      validations(values, 'accPaymentTerms', [vCase.require], errors)
      validations(values, 'paymentMethod', [vCase.require], errors)
      validations(values, 'tradingPartner', [vCase.require], errors)
      validations(values, 'branchCode', [vCase.require], errors)
      validations(values, 'branchDescription', [vCase.require], errors)
    }
  }

  if (values.purpose === 'copy') {
    validations(values, 'copyType', [vCase.require], errors)

    if (values.copyType === 'company') {
      if ((values.companies || []).length === 0) {
        errors.companies = 'Require!'
      }
    }

    if (values.copyType === 'purchasingOrg') {
      validations(values, 'purchasingOrg', [vCase.require], errors)

      if (values.purchasingOrg) {
        if ((values.copyPurchasingOrg || []).length === 0) {
          errors.copyPurchasingOrg = 'Require!'
        }
      }
    }
  }

  if (values.purpose === 'create' || values.purpose === 'copy') {
    if ((['ZDOV', 'ZFIN', 'ZOTV', 'ZRPT', 'ZRCP'].includes(values.accountGroup) && values.paymentTypeTransfer)) {
      if (values.receiveEWht === null || values.receiveEWht === undefined) {
        errors.receiveEWht = 'Require!'
      }
    }
  }

  return errors
}

const VendorMaintenanceCreateForm = reduxForm({
  form: 'formVendorMaintenance',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(VendorMaintenanceCreate)

export default connect(mapStateToProps, mapDispatchToProps)(VendorMaintenanceCreateForm)
